import { render } from "./footer_info.vue?vue&type=template&id=2efed315"
import script from "./footer_info.vue?vue&type=script&lang=js"
export * from "./footer_info.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__